const motionDurations = {
  t0: 50,
  t1: 100,
  t2: 200,
  t3: 300,
  t4: 400,
  t5: 500,
  t6: 1000
}

const motionGraphs = {
  linear: 'cubic-bezier(0.0, 0.0, 1.0, 1.0)',
  standard: 'cubic-bezier(0.5, 0.0, 0.5, 1.0)',
  easeOut: 'cubic-bezier(0.0, 0.0, 0.0, 1.0)',
  easeInOut: 'cubic-bezier(0.33, 0, 0.53, 1)',
  ease: 'cubic-bezier(0.33, 0, 0.25, 1)'
}

export default {
  motionDurations,
  motionGraphs
}
